// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__MH1du","track":"Switch_track__3MayM","slider":"Switch_slider__eaJnm","option":"Switch_option__K9y-K","active":"Switch_active__Io0Cz"};